import { Ref, ref } from "@vue/composition-api";
import { PIIDashboardItem } from "./models";
import { SharedState } from "@/common/state";
import { InformationType } from "@/common/models";
import * as api from "./api";

const DASHBOARD_SEED: PIIDashboardItem[] = ["SPI", "PII", "PFI", "PCI"].map(
  (title) => {
    return {
      title,
      items: [],
    };
  }
);

const items: Ref<PIIDashboardItem[]> = ref(DASHBOARD_SEED);

const map_result = (api_res: Array<{ count: number; labelId: string }>) => {
  const PIIS = SharedState.PII.L1();
  const indexed_pii_counts = api_res
    .map(
      ({ count, labelId }) =>
        [SharedState.getInfoType(labelId), count] as [InformationType, number]
    )
    .filter(([f]) => f && f.code == 7)
    .reduce((acc, [info, count]) => {
      acc[info.id] = count;
      return acc;
    }, {} as Record<string, number>);
  // @ts-ignore
  items.value = PIIS.map((d) => {
    return {
      title: d.labelName,
      items: d.nested
        .map((l) => {
          return {
            type: "count",
            id: l.id,
            name: l.labelName,
            sensitivity: l.sensitivityLevel,
            count: indexed_pii_counts[l.id] || 0,
          };
        })
        .sort((a, b) => b.count - a.count),
    };
  });
};

const load_data = async (payload: {
  session_id: number;
  root_folder_id: string;
}) => {
  const pii_ids = SharedState.PII.L1()
    .map((d) => {
      const ids = d.nested.map((l) => l.id);
      // @ts-ignore
      if (!d.fake) {
        ids.push(d.id);
      }
      return ids;
    })
    .flat();
  const res = await api.get_all_piis({
    root_folder_id: payload.root_folder_id,
    session_id: payload.session_id,
    pii_ids,
  });
  if (res.success) {
    map_result(res.value);
  }
};

export const pii_state = {
  load_data,
  items,
};
